export default "__VITE_ASSET__DUJyfyok__"